import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import "../../styles/trainer/trainer.css";
import "../../styles/home/home.css";
import "../../styles/trainer-member/trainer-member.css";
import "../../styles/staff-report/staff-attendance-report.css";
import HelmetWrapper from "../../HelmetWrapper";
import StaffAttendanceReport from "../../components/trainer-report/staff-attendance-report/StaffAttendanceReport";
import { selectAuth } from "../../components/auth/auth.selector";

const AttendanceReport = () => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};

  return (
    <HelmetWrapper title="WTF: Attendance Report">
      <Container className="bg-cloud-k px-50px" fluid>
        <StaffAttendanceReport userInfoData={user} />
      </Container>
    </HelmetWrapper>
  );
};

export default AttendanceReport;
